'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';

// Loads the Securiti.ai cookie consent SDK and handles RTL button ordering for Arabic.
// The SDK is loaded via next/script (afterInteractive, like the GTM install on our other
// sites) rather than from a useEffect, so the URL is already correct when the banner
// first renders and Arabic pages show the Arabic banner.
export default function CookieConsent() {
  const pathname = usePathname();
  const isArabic = pathname?.startsWith('/ar');

  return (
    <>
      <Script
        id="securiti-consent-sdk"
        src="https://cdn-prod.eu.securiti.ai/consent/cookie-consent-sdk-loader.js"
        strategy="afterInteractive"
        data-tenant-uuid="afd75cd2-cbaa-4d9b-8b84-37598fb2e16f"
        data-domain-uuid="72c272e3-3712-4017-8c2f-07b475397837"
        data-backend-url="https://app.eu.securiti.ai"
        data-skip-css="false"
        onLoad={() => {
          var origin = window.location.origin;
          var langMap = {};
          langMap[origin + '/ar'] = 'ar';
          langMap[origin + '/en'] = 'en';
          window.setConsentBannerParams({
            overrideBannerLanguage: langMap,
          });
        }}
      />

      {/* Reorder consent buttons for Arabic so the primary action appears on the right (RTL layout) */}
      {isArabic && (
        <style>{`
          .cc-compliance .cc-allow { order: 3; }
          .cc-compliance .cc-dismiss { order: 2; }
          .cc-compliance .cmp-pref-link { order: 1; }
        `}</style>
      )}
    </>
  );
}
